var React = require('react');

function Valid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.563,12.563a12,12,0,1,1-12-12A12,12,0,0,1,24.563,12.563ZM11.174,18.916l8.9-8.9a.774.774,0,0,0,0-1.095L18.983,7.823a.774.774,0,0,0-1.095,0l-7.261,7.261-3.39-3.39a.774.774,0,0,0-1.095,0L5.047,12.789a.774.774,0,0,0,0,1.095l5.032,5.032a.774.774,0,0,0,1.095,0Z","transform":"translate(-0.563 -0.563)"}));
}

Valid.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Valid;

Valid.default = Valid;
